import React from 'react';
import { ChecklistItemContainer, ChecklistItemName, ChecklistTick } from '../ChecklistFilter/styled';

const ArticleOptionsFilterItem = props => {
  const { selectedType, option, onClick } = props;
  const selected = selectedType === option.value;
  return (
    <ChecklistItemContainer selected={selected} onClick={() => onClick(option.value)}>
      <ChecklistTick selected={selected} />
      <ChecklistItemName>{option.text}</ChecklistItemName>
    </ChecklistItemContainer>
  );
};

export default ArticleOptionsFilterItem;
